/*
Poornima 09/19/2022 2701350359 Fixed GAL-127,132,73,60,104 bugs
Poornima 09/23/2022 2701350359 Fixed sorting issues in report master
RajeshK 09/26/2022 2701350359 report master changes
RajeshK 09/26/2022 2701350359 fixed conflicts
Sohel 10/27/2022 3031450488 Integrated get API.
Sohel 10/27/2022 2701375033 Added Copy Functionality.
Sohel 10/29/2022 2701350359 Added in Payload Created For and Created By Fields
Prakash  10/26/2022 2701350359 Added classes for Table UI,Buttons and Icons.
Ashraf  10/29/2022 2701350359 Added create new button to create a new report
Prakash 10/29/2022 2701350359 Added New UX Changes for Buttons and Tables.
Sohel 10/30/2022 2701350359 Added status column
Sohel 10/30/2022 2701350359 rule group code changes field name
Prakash 10/30/2022 2701350359 Added New UX Changes for  Table Status Chips.
Ashraf 10/30/2022 2701350359 changed button label
Prakash 10/31/2022 2701350359 Removed Inline-styles for table.
Dilip 10/31/2022  2701350359 added clickable functionality for report code
Ashraf 10/31/2022  2701350359 aligned add report button to left
Akhila 10/31/2022  2701350359 implemented download in table
Sai mahesh 10/31/2022 2701350359 added status styling
lalitha 11/01/2022 2701350359 added span element in column link
akhila 11/02/2022 2701350359 adding title and draft in payload and title field
Saikrishna 11/03/2022 3031450488 prompt API call made properly when needed for dynamic fields rendering
saikrishna 11/03/2022 2701350359 changed the paginationOptions
Dilip 11/03/2022 2701350359 Added report code in delete popup
akhila 11/04/2022 2701350359 integrated print api.
Sohel 11/05/2022 2701350359 Added Tootltip and disable Condition
Sohel 11/05/2022 2701350359 rename tooltip and download configuration
akhila 11/04/2022 2701350359 added when no records download usage will disabled.
akhila 11/08/2022 2701350359 adding report notes
akhila 11/08/2022 2701350359 changed copyCode in report master.
akhila 11/09/2022  2701350359 changed title field
akhila 11/10/2022  2701350359 changed report note alignment
Dilip 11/11/2022  2701350359 changed download configuration payload
Rajesh 11/15/2022 2701350359 added props to conditionally render actions.
Saikrishna 11/14/2022 2701350359 Removed un used API call.
Rajesh 11/16/2022 2701350359 changed passing props to report table.
Akhila 11/25/2022 2701350359 Bug fixed search functionality
Rajesh 11/25/2022 2701350359 added condition for night jobs to show completed status
Saikrishna 11/28/2022 2701350359 Proper state update for fixedlength and isDaft.
Ravi 11/29/2022 2701350359  fixed MuiTable action conditional rendering
Saikrishna 11/30/2022 2701350359  required changes dne for reports
Prakash 12/01/2022 2701350359 fixed Table word wrap issues.
Sai maheshwar 12/01/2022 2701350359 fixed runreport download issue.
Sai krishna 12/02/2022 2701350359 Added history execution popup.
Saikrishna 12/02/2022 3031450488 execution done.
Sai Maheshwar 12/05/2022 3031450488 added map fields save and close
Sohel 12/05/2022 2701350359 created For payload Changes
lalitha 12/07/2022 2701350359 added created by payload in search table
akhila 12/07/2022 3031450488 disable report execution for draft record
Ravi 12/07/2022 2701350359  Fixed UAT bugs
akhila 12/08/2022 2701350359 adding session storage for search items
Ashraf 12/09/2022 2701350359 fixed download configuration created For issue
Ashraf 12/09/2022 2701350359 fixed download configuration created By issue
kavya9reddy 12/09/2022 2701350359 Added createdDate in payload
Sohel 12/13/2022 2701350359 conditionally hide Save Button
Akhila 12/13/2022 2701350359 bugFix session stoarge
Ashraf 12/14/2022 2701350359 removed role access
Saikrishna 12/18/2022 3225736869 Fixed jira bugs by QA on night jobs
Raghu 12/26/2022 3225736869 Added Dialog Component
Ashraf 12/27/2022 3225736869 disable history icon when role access is not given
kavyareddy 12/27/2022 3225736869 Increased the execution pop up width
sai krisha 30/12/2022 3225736869 add code description values
Ashraf 30/12/2022 3225736869 renamed copy report
manikanta 01/06/2023 3225736869 changed edit icon position
Ashraf 01/19/2022 2692790263 Added last run date column
Akhila 02/03/2023 2692790263 Added last run date in payload
kavyareddy 02/07/2023 2692790263 payload changes in createdBy
Rohini 02/09/2023 2698964415 Added the new classname.
Sohel 02/09/2023 3031450488 Added runManually in payload
Dilip 02/09/2023 2700753823 added created for dropdown
Dilip 02/09/2023 2700753823 added created for dropdown
sai krisha 02/13/2022 2700753823 added lastrundate in download configuration
sai krisha 02/13/2022 2700753823 added  client code field
Guru Prasad 02/13/2023 3225736869 Added tooltip for the client code
Ravi 02/24/2023 3225736869 implemented previewFile in download Configuration
Dilip 02/27/2023 3225736869 Fixed Sorting issue
Akhila 03/02/2023 3225736869 Added loader and download toast message for preview File
Raghu 03/16/2023 3225736869 fixed action table
Akhila 03/17/2023 3225736869 bug fixed in scheduler add task trigger reusable component fix
Akhila 05/10/2023 3225736869 modified download for excel file in execution
Sohel 05/12/2023 3225736869 Fixed Reset Select Fields issue
Ravi 05/31/2023 3225736869 changed delete popup message
Sohel 06/01/2023 2692790263 disable Executions and run in draft mode
Akhila 06/07/2023 2692790263 Added code and description
Akhila 06/08/2023 2692790263 created date change to date created field and column
Sohel 06/14/2023 2692790263 Fixed Access Methods Reset Issue
Sohel 06/16/2023 2692790263 Added WorkQUeue in Add Task
Sohel 06/20/2023 2692790263 Fixed WorkQueue Code data Issue
Sohel 06/21/2023 2692790263 Fixed Field Prepopulate issue
//Ravi 07/22/2023 2692790263 increased copy popup size
uday  19/10/2023 2692790263 fixed add table scroll issue
Sohel 12/10/2023 2692790263 bug fixed reset issue when extra space searching
*/

import React, {useContext, useEffect, useState, useRef} from 'react';
// import MaterialTable from "material-table";
import {Button, Grid, TablePagination, Tooltip} from '@material-ui/core';
import {tableIcons} from '../../../../components/TableIcons';
import {httpPaginationPost, httpPaginationDelete} from '../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {SuccessSnackbar, ErrorSnackbar} from '../../../../components/CustomSnackBar';
import moment from 'moment';
import {
  getDropDownData,
  getClientCodeData,
  getAccessMethodRunList,
  postFieldCode,
  postPrintRecordMaster,
  ResetMessage as resetMsg,
  getCollectorsData,
  resetConfigUrl,
  resetDockey,
  getFieldCode,
  ResetUrl as resetUrl,
} from '../../../../redux/reducers/BRE/AddReportMaster';
import PreviewFileDialog from '../../../../util/PreviewFileDialog';
import axios from 'axios';
import {
  fetchBasicInfo,
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
  fetchFilter,
  resetCopyReport,
  resetCreateReport,
  resetMessage,
  resetReportFieldsData,
  resetReportSchedule,
  setReduxState,
} from '../../../../redux/reducers/ReportMaster/index';
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {resetReportMaster} from '../../../../redux/reducers/ReportMaster/index';
import DialogBox from './../../../../components/DialogBox/index';
import CopyReport from './CopyReport';
import {makeStyles} from '@material-ui/core';
import {tablePageRows} from '../../../../constants/ReusableConstants';
import ReportNote from './ReportNote';
import PageLoader from '../../../../components/PageLoader';
import ReportsExecutionTable from './ReportsExecutionTable';
import {REPORTING_EXPORT} from '../../../../constants/ReusableRoleAccess';
import {useUpdateEffect} from 'react-use';
import {downloadButton} from '../../../../util/Content';
import {resetDownloadMsg} from '../../../../redux/reducers/PreviewFileData';
import {MTableToolbar} from 'material-table';
import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../../util/ActionMenuItem';
import {ResetExecelSucessMsg as resetExecelSucessMsg} from '../../../../redux/reducers/BRE/AddReportMaster';
const useStyles = makeStyles((theme) => ({
  link: {
    // Changed color for Group Code Column (2700780638)
    color: '#320469 !important',
  },
}));
export default function ReportMasterSearchTable({
  setSelectedRows,
  selectedRows,
  setTabValue,
  setOpen,
  setReportDialogData,
  // setReportCode,
  setSubmit,
  submit,
  searchData,
  setSearchData,
  copy,
  setCopy,
  reportMasterSearch,
  setReportSearchCode,
  setReportSearch,
  setReportData,
  setEditExisting,
}) {
  const rowDataRef = useRef();
  const queryRef = useRef(null);
  const onEditCall = (rowData) => {
    dispatch(setReduxState({property: 'fixedlength', value: rowData?.fixedLength}));
    dispatch(setReduxState({property: 'isDraftReport', value: rowData?.isDraft}));
    dispatch(setReduxState({property: 'lastStep', value: rowData?.lastStep}));
    if (!reportMasterSearch) {
      // dispatch(fetchReportMaster(rowData?.reportCode));
      // dispatch(fetchBasicInfo(rowData?.reportCode));
      setTabValue(1);
      dispatch(setReduxState({property: 'reportCode', value: rowData?.reportId}));
      dispatch(setReduxState({property: 'reportName', value: rowData?.reportCode}));
      // setReportCode(rowData?.reportCode);
      // rowData?.accessMethod &&
      //   rowData?.action &&
      //   dispatch(
      //     postFieldCode({
      //       fieldCode: rowData?.accessMethod,
      //       options: rowData?.action,
      //     })
      //   );
    }
    if (reportMasterSearch) {
      dispatch(fetchFilter(rowData?.reportId));
      dispatch(getAccessMethodRunList());
      // dispatch(fetchReportMaster(rowData?.reportCode));
      // rowData.accessMethodInfo = {
      //   accessMethod: rowData.accessMethod || null,
      //   action: rowData.action || null,
      // };
      setReportData(rowData);
      setReportSearchCode(rowData);
      setReportSearch(false);
      rowData?.accessMethod &&
        rowData?.action &&
        dispatch(
          postFieldCode({
            fieldCode: rowData?.accessMethod,
            options: rowData?.action,
          }),
        );
    }
  };
  const columns = [
    {
      title: 'Report Name',
      field: 'reportCode',
      render: (rowData) => (
        <span
          role="button"
          className={`table-word-wrap-border ${classes1.link}`}
          // style={{ backgroundColor: "transparent" }}
          onClick={() => {
            onEditCall(rowData);
            !reportMasterSearch && setEditExisting(rowData?.reportCode);
          }}
        >
          {rowData?.reportCode?.replace(/ /g, '\u00a0')}
        </span>
      ),
    },
    // {
    //   title: "Report Title",
    //   field: "title",
    //   render: (rowData) => <>{rowData?.title}</>,
    // },
    // {
    //   title: "Record Format Code",
    //   field: "recordFormatCode",
    // },
    {
      title: 'Report Description',
      field: 'reportDescription',
      cellStyle: {
        minWidth: 250,
        maxWidth: 350,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      render: (rowData) => {
        return (
          <Tooltip title={rowData?.reportDescription} interactive>
            <span className="text-wraper">{rowData?.reportDescription.replace(/ /g, '\u00a0')}</span>
          </Tooltip>
        );
      },
    },
    {
      title: 'Report Owner',
      field: 'createdFor',
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
    {
      title: 'Status',
      field: 'isDraft',
      render: (rowData) =>
        rowData?.isDraft === 'Y' ? (
          <div className="completed-status status">
            <span style={{color: '#ff8b00', fontWeight: 'bold'}}>Draft</span>
          </div>
        ) : (
          <div className="completed-status status" style={{fontWeight: 'bold', color: '#00af00'}}>
            <span>Completed</span>
          </div>
        ),
    },
    {
      title: 'Last Run Date',
      field: 'lastRunDate',
      render: (rowData) => {
        return rowData?.lastRunDate ? moment(rowData?.lastRunDate).format('MM/DD/YYYY') : '';
      },
    },
  ];
  const {reusableInputStyles} = useContext(ThemeContext);
  const tableRef = useRef();
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [countTotal, setCountTotal] = useState('');
  const [userData, setUserData] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  const [isNote, setIsNote] = useState(false);
  const [status, setStatus] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);
  const {
    isLoading,
    successMsg,
    viewFormFileUrl,
    errorMsg,
    runReportToggle,
    configurationUrl,
    dockey,
    downloadMsgExcel,
  } = useSelector(({addReportMaster}) => addReportMaster);
  const {copySuccessMsg, copyErrorMsg, copyReportStatus, copyCode} = useSelector(
    ({reportMaster}) => reportMaster,
  );
  const [copyReport, setCopyReport] = useState(false);
  const {roleData} = useSelector(({role}) => role);
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [deleteSuccessMsg, setDeleteSuccessMsg] = useState('');
  const reportRoleAccess = roleData?.window?.[REPORTING_EXPORT]?.RE;
  const [oldReportCode, setOldReportCode] = useState('');
  const [codeAndDescription, setCodeAndDescription] = useState({});
  const [reportCodeData, setReportCodeData] = useState();
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [reportExecution, setReportExecution] = useState(false);
  const [loading, setLoading] = useState(false);
  const classes1 = useStyles();
  useEffect(() => {
    if (successMsg || errorMsg || downloadMsgExcel) {
      setTimeout(() => {
        dispatch(resetMsg());
        dispatch(resetExecelSucessMsg());
      }, 3000);
    }
  }, [successMsg, errorMsg, downloadMsgExcel]);

  useUpdateEffect(() => {
    if (status === true) {
      dispatch(fetchCreatedByDropDownData('report'));
      dispatch(fetchCreatedForDropDownData('report'));
      setStatus(false);
    }
  }, [status]);

  useEffect(() => {
    dispatch(resetMessage('search'));
    dispatch(resetReportSchedule());
    dispatch(resetReportFieldsData());
    dispatch(getFieldCode());
  }, []);

  useEffect(() => {
    if (configurationUrl) {
      setLoading(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setLoading(false);
      }
      readData();
    }
  }, [configurationUrl]);

  useEffect(() => {
    if (deleteErrorMsg || deleteSuccessMsg) {
      setTimeout(() => {
        setDeleteErrorMsg('');
        setDeleteSuccessMsg('');
      }, 3000);
    }
  }, [deleteErrorMsg, deleteSuccessMsg]);
  useEffect(() => {
    dispatch(getDropDownData());
    dispatch(getClientCodeData());
    dispatch(getCollectorsData());
    !reportMasterSearch && setCopy(null);
  }, [dispatch]);

  useEffect(() => {
    if (copyReportStatus === 200) {
      setTimeout(() => {
        dispatch(fetchBasicInfo(copyCode));
        dispatch(resetCopyReport());
        setTabValue(1);
        setCopyReport(false);
      }, 2500);
    }
  }, [copyReportStatus]);

  useEffect(() => {
    if (copyErrorMsg || copySuccessMsg) {
      setTimeout(() => {
        dispatch(resetCopyReport());
      }, 2500);
    }
  }, [copyErrorMsg, copySuccessMsg]);

  useEffect(() => {
    if (viewFormFileUrl && viewFormFileUrl.includes('https')) {
      window.open(`${viewFormFileUrl}`, '_parent');
      dispatch(resetUrl());
    }
  }, [viewFormFileUrl]);
  useEffect(() => {
    if ((tableRef.current && submit) || runReportToggle) {
      if (runReportToggle) {
        tableRef?.current?.onQueryChange();
      } else {
        Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
      }
    }
  }, [submit, successMsg, searchData]);

  const handleDelete = (rowData) => {
    setUserData(rowData);
    setIsDelete(true);
  };
  const handleNote = () => {
    setIsNote(true);
  };
  const handleEdit = (rowData) => {
    onEditCall(rowData);
    !reportMasterSearch && setEditExisting(rowData?.reportCode);
  };
  const handleNotes = (rowData) => {
    setReportCodeData(rowData);
    handleNote();
  };
  const handleExecution = (rowData) => {
    setReportExecution(true);
    rowDataRef.current = rowData;
  };
  const handleRun = (rowData) => {
    if (rowData?.reportId) {
      dispatch(fetchFilter(rowData?.reportId));
    }
    setOpen(true);
    rowData?.accessMethod &&
      rowData?.action &&
      dispatch(
        postFieldCode({
          fieldCode: rowData?.accessMethod,
          options: rowData?.action,
        }),
      );
    setReportDialogData(rowData);
    dispatch(getAccessMethodRunList());
  };
  const handleCopy = (rowData) => {
    setCopy(rowData.reportId);
    setCopyReport(true);
    setOldReportCode(rowData?.reportCode);
    setCodeAndDescription(rowData);
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
    setIsNote(false);
  };

  const handleCopyReport = () => {
    setCopyReport(false);
  };
  const handleSubmit = () => {
    setIsLoadingDelete(true);
    new Promise((resolve) => {
      httpPaginationDelete(`reportstransaction/delete/txnreport/${userData.reportId}`)
        .then((response) => {
          if (response?.status === 200 && response?.data?.status !== 400) {
            setDeleteSuccessMsg(response?.response);
            setSubmit(true);
            tableRef.current.onQueryChange();
            setStatus(true);
            handleCloseDialog();
            setIsLoadingDelete(false);
            resolve();
          }
          if (response?.data?.status === 400) {
            setDeleteErrorMsg(response.data.message);
            resolve();
            handleCloseDialog();
            setIsLoadingDelete(false);
          }
          resolve();
        })
        .catch((error) => {
          console.log(error);
          setIsLoadingDelete(false);
        });
    });
  };
  useEffect(() => {
    dispatch(resetReportMaster());
    !reportMasterSearch && setEditExisting('');
  }, []);
  const handleReportHistory = () => {
    setReportExecution(false);
  };

  const SearchSessionReport = JSON.parse(sessionStorage.getItem('Report'));
  if (SearchSessionReport && !submit && !reportMasterSearch) {
    searchData = SearchSessionReport;
  }
  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };
  return (
    <>
      <DialogBox
        open={reportExecution}
        dialogClose={handleReportHistory}
        title="Report Execution History"
        maxWidth="xl"
        hideFooter={true}
      >
        <ReportsExecutionTable executionRowData={rowDataRef?.current} />
      </DialogBox>
      <DialogBox
        open={copyReport}
        dialogClose={handleCopyReport}
        title="Copy Report"
        maxWidth="xl"
        hideFooter={true}
      >
        <CopyReport
          oldReportCode={oldReportCode}
          oldReportId={copy}
          codeAndDescription={codeAndDescription}
        />
      </DialogBox>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Reporting/Export'}
      />
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title="Delete Report"
        value={`Are you sure you want to delete the ${userData?.reportCode} Report?`}
        handleSubmit={handleSubmit}
      />
      <DialogBox
        open={isNote}
        dialogClose={handleCloseDialog}
        title="Report Notes"
        maxWidth="lg"
        hideFooter={true}
      >
        <ReportNote reportCodeData={reportCodeData} />
      </DialogBox>

      <Grid item xs={12}>
        <div
          className={
            !reportMasterSearch ?
              'custom-table  custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields actions-dropdown-table tablescroll-block' :
              'custom-table  custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields tablescroll-block'
          }
        >
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            isLoading={isLoading}
            data={(query) =>
              new Promise((resolve) => {
                const url = `reportstransaction/search/all`;

                const bodyObj = {
                  reportCode: searchData?.code ? searchData.code : '',
                  reportDescription: searchData?.description ? searchData.description : '',
                  createdBy: searchData?.createdBy?.userLoginName ?
                    searchData?.createdBy?.userLoginName :
                    '',
                  createdFor: searchData?.createdFor?.userLoginName ?
                    searchData?.createdFor?.userLoginName :
                    '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  limit: query.pageSize ? query.pageSize : null,
                  reportType: 'REPORT',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  orderDirection: query.orderDirection,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  isDraft: reportMasterSearch ?
                    'N' :
                    searchData?.isDraft?.key ?
                      searchData?.isDraft?.key :
                      '',
                  title: searchData?.title ? searchData?.title : '',
                  lastRunDate: searchData?.lastRunDate ?
                    moment(searchData?.lastRunDate).format('MM/DD/YYYY') :
                    '',
                  clientCode: searchData?.clientCode?.clientNumber ?
                    searchData?.clientCode?.clientNumber :
                    '',
                };
                queryRef.current = query;
                // setOrder({
                //   orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : "",
                //   orderDirection: query?.orderDirection ? query?.orderDirection : "",
                // });
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      setSubmit(false);
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setCountTotal(response.data.response.count);
                        setArrayLast(data.length === 1);
                        // setReportCode(null);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbarButtonAlignment: 'left',
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            localization={{
              header: {
                actions: reportMasterSearch ? '' : 'Actions',
              },
            }}
            // actions={
            //   !reportMasterSearch && [
            //     {
            //       icon: () => (
            //         <>
            //           <Button
            //             type="button"
            //             variant="outlisetOpenned"
            //             className={`mx-1 search-btn`}
            //             disabled={!reportRoleAccess?.add}
            //           >
            //             Create Reporting/Export
            //           </Button>
            //         </>
            //       ),
            //       isFreeAction: true,
            //       disabled: !reportRoleAccess?.add,
            //       hidden: reportMasterSearch,
            //       onClick: (event) => {
            //         dispatch(setReduxState({ property: "isDraftReport", value: "Y" }));
            //         setTabValue(1);
            //         dispatch(resetCreateReport());
            //       },
            //     },
            //     (rowData) => ({
            //       icon: () => <EditOutlinedIcon />,
            //       tooltip: "Edit",
            //       hidden: rowData?.repositoryType === "SYSTEM",
            //       disabled: !reportRoleAccess?.edit,
            //       onClick: (event, rowData) => {
            //         onEditCall(rowData);
            //         !reportMasterSearch && setEditExisting(rowData?.reportCode);
            //       },
            //     }),
            //     (rowData) => ({
            //       icon: () => <PlayCircleOutlineOutlinedIcon />,
            //       tooltip: rowData?.isDraft !== "Y" ? "Run" : "",
            //       disabled: rowData?.isDraft === "Y" || !reportRoleAccess?.edit,
            //       hidden: reportMasterSearch,
            //       onClick: (event, rowData) => {
            //         setOpen(true);
            //         rowData?.accessMethod &&
            //           rowData?.action &&
            //           dispatch(
            //             postFieldCode({
            //               fieldCode: rowData?.accessMethod,
            //               options: rowData?.action,
            //             })
            //           );
            //         setReportDialogData(rowData);
            //         dispatch(getAccessMethodRunList());
            //         // dispatch(getRunReportData(rowData.reportId));
            //       },
            //     }),
            //     // (rowData) => {
            //     //   if (rowData?.docKey) {
            //     //     return {
            //     //       icon: () => <GetAppOutlinedIcon />,
            //     //       tooltip: "Download",
            //     //       hidden: reportMasterSearch,
            //     //       onClick: (event, rowData) => {
            //     //         dispatch(
            //     //           postGenerateUrl({
            //     //             dockey: rowData?.docKey,
            //     //           })
            //     //         );
            //     //         // dispatch(downloadFileByUrl(rowData?.documentKey));
            //     //       },
            //     //     };
            //     //   } else {
            //     //     return {
            //     //       icon: () => <GetAppOutlinedIcon />,
            //     //       hidden: reportMasterSearch,
            //     //       disabled: true,
            //     //     };
            //     //   }
            //     // },
            //     (rowData) => ({
            //       icon: () => <HistoryIcon />,
            //       // hidden: nightJobSearchTrigger,
            //       disabled: rowData?.isDraft === "Y",
            //       tooltip: rowData?.isDraft !== "Y" ? "Report executions" : "",
            //       onClick: (event, rowData) => {
            //         setReportExecution(true);
            //         rowDataRef.current = rowData;
            //         // dispatch(triggerExecutions(rowData?.groupCode));
            //       },
            //     }),
            //     (rowData) => ({
            //       icon: () => <FileCopyOutlinedIcon />,
            //       tooltip: "Copy",
            //       hidden: reportMasterSearch,
            //       disabled: !reportRoleAccess?.add,
            //       onClick: (event, rowData) => {
            //         // dispatch(fetchReportMaster(rowData.reportCode));
            //         // setTabValue(1);
            //         setCopy(rowData.reportId);
            //         setCopyReport(true);
            //         setOldReportCode(rowData?.reportCode);
            //         setCodeAndDescription(rowData);
            //       },
            //     }),
            //     {
            //       icon: () => <DeleteOutlineOutlinedIcon className={classes.copyButtonroot} />,
            //       tooltip: "Delete",
            //       hidden: reportMasterSearch,
            //       onClick: (event, rowData) => handleDelete(rowData),
            //       disabled: !reportRoleAccess?.delete,
            //       // disabled: !reportRoleAccess,
            //     },
            //     {
            //       icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
            //       tooltip: "Report Notes",
            //       hidden: reportMasterSearch,
            //       onClick: (event, rowData) => {
            //         setReportCodeData(rowData?.reportCode);
            //         handleNote();
            //       },
            //     },
            //   ]
            // }
            actions={
              !reportMasterSearch && [
                {
                  icon: () => <SaveIcon />,
                  tooltip: 'Save User',
                  onClick: (event, rowData) => console.log(rowData, 'rowData'),
                },
              ]
            }
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <div className="mt-2">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`search-btn ml-2 ${classes.buttonRoot}`}
                      disabled={Boolean(countTotal === 0)}
                      onClick={() => {
                        dispatch(
                          postPrintRecordMaster({
                            reportDescription: searchData?.description ?
                              searchData.description :
                              '',
                            reportCode: searchData?.code ? searchData.code : '',
                            orderBy:
                              queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                queryRef.current.orderBy.field :
                                '',
                            orderDirection: queryRef.current?.orderDirection ?
                              queryRef.current?.orderDirection :
                              '',
                            reportTitle: searchData?.title ? searchData?.title : '',
                            createdBy: searchData?.createdBy?.userLoginName ?
                              searchData?.createdBy?.userLoginName :
                              '',
                            createdFor: searchData?.createdFor?.userLoginName ?
                              searchData?.createdFor?.userLoginName :
                              '',
                            createdDate: searchData?.createdDate ?
                              moment(searchData?.createdDate).format('MM/DD/YYYY') :
                              '',
                            isDraft: searchData?.isDraft?.key ?
                              searchData?.isDraft?.key :
                              reportMasterSearch ?
                                'N' :
                                '',
                            lastRunDate: searchData?.lastRunDate ?
                              moment(searchData?.lastRunDate).format('MM/DD/YYYY') :
                              '',
                            clientCode: searchData?.clientCode?.clientNumber ?
                              searchData?.clientCode?.clientNumber :
                              '',
                          }),
                        );
                      }}
                    >
                      {downloadButton}
                    </Button>
                  </div>
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleNotes={handleNotes}
                  handleRun={handleRun}
                  handleExecution={handleExecution}
                  handleCopy={handleCopy}
                  hiddenMenu={{
                    edit: props?.data?.repositoryType === 'SYSTEM',
                    run: false,
                    copy: reportMasterSearch,
                    test: true,
                    notes: reportMasterSearch,
                    execution: false,
                    usage: true,
                    user: true,
                    password: true,
                    delete: reportMasterSearch,
                  }}
                  disableMenu={{
                    disableEdit: !reportRoleAccess?.edit,
                    disableRun:
                      props?.data?.isDraft === 'Y' ||
                      (!reportRoleAccess?.add && !reportRoleAccess?.edit),
                    disableCopy: !reportRoleAccess?.add,
                    disableExecution: props?.data?.isDraft === 'Y',
                    disableNotes: false,
                    disableTest: false,
                    disableUsage: false,
                    disableUser: false,
                    disablePassword: false,
                    disableDelete: !reportRoleAccess?.delete,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div>
                    {!reportMasterSearch && (
                      <Button
                        type="button"
                        variant="outlisetOpenned"
                        className={`mx-1 search-btn`}
                        disabled={!reportRoleAccess?.add}
                        isFreeAction={true}
                        onClick={(event) => {
                          dispatch(setReduxState({property: 'isDraftReport', value: 'Y'}));
                          setTabValue(1);
                          dispatch(resetCreateReport());
                        }}
                      >
                        Create Reporting/Export
                      </Button>
                    )}
                  </div>
                </div>
              ),
            }}
          />
        </div>
        {deleteErrorMsg && <ErrorSnackbar errorMsg={deleteErrorMsg} />}
        {deleteSuccessMsg && <SuccessSnackbar successMsg={deleteSuccessMsg} />}
      </Grid>
      {(isLoadingDelete || loading) && <PageLoader />}
      {(errorMsg || copyErrorMsg) && <ErrorSnackbar errorMsg={errorMsg || copyErrorMsg} />}
      {(successMsg || copySuccessMsg || downloadMsgExcel) && (
        <SuccessSnackbar successMsg={successMsg || copySuccessMsg || downloadMsgExcel} />
      )}
    </>
  );
}
